// Writer 23, 2026-09-24 brief — the wire spelling of `RuntimeV3ClaimRole`
// (`@helix/lib/runtime-v3/claim`), re-exported under its own DTO name so
// `ask-helix.ts` — which serves both runtime-v3 producers and the ~20 legacy
// SDK-loop producers that have no notion of a runtime-v3 claim — never
// imports a runtime-v3 internal type by name (matching the established
// pattern of `ask-helix-claim-domain.ts`'s own file for `claimDomain`).
// SAME array, not a second literal: a role added to the canon is a role
// available here with no edit and no drift to keep in step.
import { RUNTIME_V3_CLAIM_ROLES } from './runtime-v3/claim';

export const ASK_HELIX_CLAIM_ROLES = RUNTIME_V3_CLAIM_ROLES;

export type AskHelixClaimRoleDto = (typeof ASK_HELIX_CLAIM_ROLES)[number];
